import { Component, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth-service.service';

@Component({
  selector: 'app-menu',
  imports: [RouterModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  menu = input<any[]>();
  route = inject(Router);
  authService = inject(AuthService);
  item: any;

  logout() {
    this.authService.clearSessionStorage();
    this.route.navigate(['/login']);
  }
}
